/*
@file    index.jsx

@author Carlos Sepúlveda. <csepulveda@atentus.com>
(c) Servicios de Monitoreo S.A. - Santiago, Chile

@brief  Realiza petición a la api para obtener los datos de notificaciones activas asociadas al usuario.
@date   Feb/2021

*/
import { api_host, api_auth} from '../../common/globals/constants';
/*
@brief Método envia peticion a api para obtener notificaciones activas del usuario.
@param token  corresponde a el token de autentificacion para la api.
@param userIdReport  usuario id de reporte.
@return Promise de la petición a la api.
*/
export const getUserNotifications = (token, userIdReport) => fetch(api_host+`/reporte/general/userNotifications/?user_id_report=${userIdReport}&token=${token}&key=07374CEAC2EAEF2EB3441BA0C433F9834E6CF6E2`)
    .then(response => response.json())
